const description =
  'UniProt is the world\u2019s leading high-quality, comprehensive and freely accessible resource of protein sequence and functional information.';
export default description;
